"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var SHOPIFY_API_BASE = 'shopify/v1';

var ShopifyConnectionApi =
/*#__PURE__*/
function () {
  function ShopifyConnectionApi() {
    (0, _classCallCheck2.default)(this, ShopifyConnectionApi);
  }

  (0, _createClass2.default)(ShopifyConnectionApi, null, [{
    key: "checkStoreName",
    value: function checkStoreName(storeName) {
      return _apiClient.default.get(SHOPIFY_API_BASE + "/store-validity", {
        query: {
          storeName: storeName
        }
      });
    }
  }]);
  return ShopifyConnectionApi;
}();

exports.default = ShopifyConnectionApi;
module.exports = exports.default;